import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../_service/message-service';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { FAQService } from 'src/app/_services/faq.service';
import { FaqManageComponent } from 'src/app/shared/components/faq-manage/faq-manage.component';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Role } from 'src/app/util/enums/role.enum';
import { ActivatedRoute } from '@angular/router';
import { Permission } from 'src/app/util/enums/permission.enum';

export interface FaqList {
  faqId: number;
  question: string;
  answer: string;
  category: string;
  display: string;
  enable: string;
  status: boolean;
}

@Component({
  selector: 'telio-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnDestroy {
  @Input() actionFeatureFlag = false;
  columns: TableColumn[];
  buttons: TableBtn[];
  faqList: FaqList[];
  actionHeader: string = '';
  tcolumns: TableColumn[];
  filterPlaceholder: string = '';
  actionFeatureLabel: string = 'New FAQ';
  initialData: any;
  subscription: Subscription = new Subscription;
  adminrole: any;
  userDetails: any = {};
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';

  constructor(readonly faqService: FAQService,
    readonly translate: TranslateService,
    readonly exportCSVService: ExportCSVService,
    readonly route: ActivatedRoute,
    private toastr: SnackbarService, public dialog: MatDialog,
    private userInfoService: UserInfoService) {
    this.rerender(this.pageList, '');
  }

  ngOnInit(): void {
    this.columns = [
      { columnDef: 'question', header: 'faq.question', cell: (element: FaqList) => `${element.question}`, sortingDisabled: false, width: 'auto' },
      { columnDef: 'answer', header: 'faq.answer', cell: (element: FaqList) => `${element.answer}`, sortingDisabled: false, width: 'auto' },
      { columnDef: 'category', header: 'faq.category', cell: (element: FaqList) => `${element.category}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'display', header: 'faq.display', cell: (element: FaqList) => `${element.display}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'enable', header: 'cpoList.status', cell: (element: FaqList) => `${element.status}`, sortingDisabled: false, width: '100px' },
    ];

    this.buttons = [
      { styleClass: 'submit', icon: 'edit', payload: (element: FaqList) => `${element.faqId}`, action: 'edit', tooltip: 'faq.edit', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { styleClass: 'submit', icon: 'delete', payload: (element: FaqList) => `${element.faqId}`, action: 'delete', tooltip: 'faq.delete', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.DELETE) }
    ];

    this.actionHeader = 'faq.action';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionFeatureLabel = 'faq.newFAQ';
    this.actionFeatureFlag = this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE);
    this.userDetails = this.userInfoService.userDetails;
    this.adminrole = this.userInfoService.isAdminGroup();
  }

  getFaqList(value, searchFilter) {
    this.subscription.add(this.faqService.getFaqList(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((res: any) => {
      this.faqList = res.data;
      this.totalDataCount = res.totalItems;
      this.setFaqMap(this.faqList)
    }, err => {
      this.toastr.error(this.translate.instant('responseFailed'));
    }));
  }

  buttonClick(event) {
    event[0] == 'edit' ? this.editFAQ(event[1]) : this.deleteFAQ(event[1]);
  }

  //edit faq
  editFAQ(id): void {
    let faq = this.faqList.filter(x => x.faqId == id);
    if (faq.length > 0) {
      let dialogRef = this.dialog.open(GeneralDialogComponent, {
        width: '100%',
        height: '500px',
        data: { component: FaqManageComponent, title: this.translate.instant('faq.editFAQ'), button: this.translate.instant('faq.updateButton'), otherbtn: this.translate.instant('faq.cancelButton'), value: faq[0] }
      }).afterClosed().subscribe((res: any) => {
        if (res && res.status == 'VALID') {
          let val: any = res.value;
          val.category = "General";
          val.enable = val.enable == 'active';
          val.faqId = faq[0].faqId;
          this.subscription.add(this.faqService.updatefaq(val).subscribe(r => {
            if (r) {
              this.toastr.success(this.translate.instant('faq.modifySuccess'));
              this.rerender(this.pageList, '');
            }
            else {
              this.toastr.error(r)
            }
          }));
        };
      });
    }
  }

  //delete faq
  deleteFAQ(id): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('faq.deleteFAQ'), otherbtn: this.translate.instant('faq.confirmNo') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.subscription.add(this.faqService.deletefaq(id).subscribe(r => {
          if (r) {
            this.toastr.success(this.translate.instant('faq.deleteSuccess'));
            this.rerender(this.pageList, '');
          }
          else {
            this.toastr.error(r)
          }
        }));
      }
    });
  }

  //add new faq
  actionFeature(event) {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '100%',
      height: '500px',
      data: { component: FaqManageComponent, title: this.translate.instant('faq.newFAQ'), button: this.translate.instant('faq.submitButton'), otherbtn: this.translate.instant('faq.cancelButton') }
    }).afterClosed().subscribe((res: any) => {
      if (res && res.status == 'VALID') {
        let val: any = res.value;
        val.category = "General";
        val.enable = val.enable == 'active';
        this.subscription.add(this.faqService.addfaq(val).subscribe(r => {
          if (r) {
            this.toastr.success(this.translate.instant('faq.addSuccess'));
            this.rerender(this.pageList, '');
          }
          else {
            this.toastr.error(r)
          }
        }));
      }
    });
  }

  //reload
  actionClick() {
    this.rerender(this.pageList, '');
  }

  //csv download
  actionCSV() {
    const options = {
      filename: this.translate.instant('faq.FAQfileName'),
      showTitle: false,
      title: this.translate.instant('faq.FAQfileName'),
      useKeysAsHeaders: true,
    }
    this.subscription.add(this.faqService.getFaqList(1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe((res: any) => {
      this.initialData = res.data;
      this.setFaqMap(this.initialData);
      this.exportCSVService.exportCSV(options, this.initialData);
    }));
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission)
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  rerender(value: any, searchFilter?: string) {
    this.getFaqList(value, searchFilter);
  }

  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  setFaqMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      item.id = i;
      item.question = !item.question ? empty : item.question;
      item.answer = !item.answer ? empty : item.answer;
      item.category = !item.category ? empty : item.category;
      item.display = !item.display ? empty : item.display;
      item.status = item.enable ? 'Enabled' : 'Disabled';
    });
  }
}
